module.exports = __webpack_public_path__ + "static/media/bandcamp.01fcc569.svg";